import _classCallCheck from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/codebuild/output/src455542086/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
/**
 * @module basic-styles/italic/italicui
 */
import { Plugin } from 'ckeditor5/src/core.js';
import { ButtonView } from 'ckeditor5/src/ui.js';
import italicIcon from '../../theme/icons/italic.svg';
var ITALIC = 'italic';
/**
 * The italic UI feature. It introduces the Italic button.
 */
var ItalicUI = /*#__PURE__*/function (_Plugin) {
  _inherits(ItalicUI, _Plugin);
  var _super = _createSuper(ItalicUI);
  function ItalicUI() {
    _classCallCheck(this, ItalicUI);
    return _super.apply(this, arguments);
  }
  _createClass(ItalicUI, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;
      var editor = this.editor;
      var t = editor.t;
      // Add bold button to feature components.
      editor.ui.componentFactory.add(ITALIC, function (locale) {
        var command = editor.commands.get(ITALIC);
        var view = new ButtonView(locale);
        view.set({
          label: t('Italic'),
          icon: italicIcon,
          keystroke: 'CTRL+I',
          tooltip: true,
          isToggleable: true
        });
        view.bind('isOn', 'isEnabled').to(command, 'value', 'isEnabled');
        // Execute command.
        _this.listenTo(view, 'execute', function () {
          editor.execute(ITALIC);
          editor.editing.view.focus();
        });
        return view;
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'ItalicUI';
    }
  }]);
  return ItalicUI;
}(Plugin);
export { ItalicUI as default };